/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_StyleInputs */

const en_update_style = /** @type {(inputs: Update_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Style`)
};

const fr_update_style = /** @type {(inputs: Update_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour le style`)
};

const de_update_style = /** @type {(inputs: Update_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stil aktualisieren`)
};

const it_update_style = /** @type {(inputs: Update_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna stile`)
};

const ru_update_style = /** @type {(inputs: Update_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить стиль`)
};

const es_update_style = /** @type {(inputs: Update_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar estilo`)
};

const zh_cn2_update_style = /** @type {(inputs: Update_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新样式`)
};

const ja_update_style = /** @type {(inputs: Update_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルを更新`)
};

const hi_update_style = /** @type {(inputs: Update_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शैली अपडेट करें`)
};

const pt_pt2_update_style = /** @type {(inputs: Update_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar estilo`)
};

/**
* | output |
* | --- |
* | "Update Style" |
*
* @param {Update_StyleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_style = /** @type {((inputs?: Update_StyleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_StyleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_update_style(inputs)
	if (locale === "de") return de_update_style(inputs)
	if (locale === "it") return it_update_style(inputs)
	if (locale === "ru") return ru_update_style(inputs)
	if (locale === "es") return es_update_style(inputs)
	if (locale === "zh-CN") return zh_cn2_update_style(inputs)
	if (locale === "ja") return ja_update_style(inputs)
	if (locale === "hi") return hi_update_style(inputs)
	if (locale === "pt-PT") return pt_pt2_update_style(inputs)
	return en_update_style(inputs)
});